import { render, staticRenderFns } from "./Iwitness.vue?vue&type=template&id=2a307bde&scoped=true"
import script from "./Iwitness.vue?vue&type=script&lang=js"
export * from "./Iwitness.vue?vue&type=script&lang=js"
import style0 from "./Iwitness.vue?vue&type=style&index=0&id=2a307bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a307bde",
  null
  
)

export default component.exports